// src/api.js

import CryptoUtils from '../util/cryptoUtils';
import { Globals } from '../global/Globals';
import axios from './axiosInstance';

export const fetchAPI = async (url) => {
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const fetchHalfPageBreif = async (url, id) => {
  try {
    const response = await axios.get(url + id+"&roleId="+CryptoUtils.getFromLocalStorage("roleId"));
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const createUserApi = async (body) => {
  const config = {
      headers: {
        'Content-Type': 'application/json' // Set the Content-Type header
      }
    };
  const apiResponse = await axios.post(Globals.ENDPOINT.CREATE_USER,body,config);
  return apiResponse;
}
export const deleteUserApi = async (UserID) => {
  const apiResponse = await axios.delete(Globals.ENDPOINT.DELETE_USER+UserID);
  return apiResponse;
};
export const updateNewUserApi = async (body,UserID) => {

  
  const config = {
      headers: {
        'Content-Type': 'application/json' // Set the Content-Type header
      }
    };
  const apiResponse = await axios.put(Globals.ENDPOINT.UPDATE_USER+UserID,body,config);
  return apiResponse;
};

export const fetchNotification = async (url, type, count) => {
  let str
  if (type) {
    str = url + `notificationStatus=${type}&count=${count}`
  } else {
    str = url + `&count=${count}`
  }
  try {
    const response = await axios.get(str);
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};
export const updateNotification = async (url, notificationId, read) => {
  const credentials = {
    "content": {
      "notificationId": notificationId,
      "read": read,
    },
  }

  const apiResponse = await axios.put(url + `?notificationId=${notificationId}&read=${read}`, credentials);
  return apiResponse;
}

export const updateProposal = async (body) => {
    const config = {
        headers: {
          'Content-Type': 'multipart/form-data' // Set the Content-Type header
        }
      };
    const apiResponse = await axios.post(Globals.ENDPOINT.SOLICITED_UPDATE_PROPOSAL,body,config);
    return apiResponse;
}
export const fetchProducer = async () => {
  const endPoint = Globals.BASE_URL + Globals.ENDPOINT.PRODUCER_DATA;
  const apiResponse = await axios.get(endPoint);
  return apiResponse.data;
};

export const updateProducer = async (data) => {
  const endPoint = Globals.BASE_URL + Globals.ENDPOINT.UPDATE_PRODUCER;

  try {
    const apiResponse = await axios.post(endPoint, data, {
      headers: {
        'Content-Type': 'multipart/form-data'//'application/json'
      }
    });
    return apiResponse.data;
  } catch (error) {
    if (error.response && error.response.data) {
      console.error("Validation error:", error.response.data);
      throw new Error(error.response.data.title || "Validation error occurred");
    } else {
      console.error("Error updating producer:", error);
      throw new Error("An error occurred while updating the producer");
    }
  }
};

export const unSolicatedProposalUpdate = async (body) => {
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const endpoint=Globals.ENDPOINT.UNSOLICITED_UPDATE_PROPOSAL+CryptoUtils.getFromLocalStorage("roleId");
  const apiResponse = await axios.post(endpoint, body, config);
  return apiResponse;
};

export const fetchAllProposalRejectionReasons = async () => {
  const apiResponse = await axios.get(Globals.ENDPOINT.ALL_PROPOSAL_REJECTION_REASONS);
  return apiResponse;
}

export const sendResetRequestLink = async (emailId) => {
  const encodedEmail = encodeURIComponent(emailId);
  const apiResponse = await axios.put(`${Globals.ENDPOINT.SEND_RESET_LINK}${encodedEmail}`, null, Globals.CONFIG);
  return apiResponse;
}

export const fetchByfilter = async (filterName) => {
  const channels = [filterName];
  const config = {
    headers: {
      'Content-Type': 'application/json' // Set the Content-Type header
    }
  };
  const apiResponse = await axios.post(Globals.ENDPOINT.HALFPAGE_BRIEF_CLUSTERS, channels, config);
  return apiResponse;
};

export const fetchChannelsByClusterID = async (clusterId) => {
  const apiResponse = await axios.get(Globals.ENDPOINT.FETCH_CHANNELS_BY_CLUSTER_ID + clusterId +"?isusingDashboard=false");
  return apiResponse;
};

export const getBriefRequests = async (body) => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.GET_BRIEF_REQUESTS;
  try {
    const apiResponse = await axios.post(endpoint, body, config);
    const data = apiResponse.data.content.briefRequest
    const newArray = data.map(({bRefNo, createdByHelper, reassignRequestedHelper,requestedDate, reassignedCluster, reassignedChannel, proposalId}) => ({
      bRefNo, createdByHelper, reassignRequestedHelper,requestedDate, reassignedCluster, reassignedChannel, proposalId
    }));
    apiResponse.data.content.simplifiedBriefRequests = newArray;
    return apiResponse;
  } catch (error) {
    throw error;
  }

}
export const getBriefShelve = async (body) => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.GET_BRIEF_SHELVE_REQUESTS;
  try {
    const apiResponse = await axios.post(endpoint, body, config);
    const data = apiResponse.data.content.briefRequest
    const newArray = data.map(({bRefNo, createdByHelper, reassignRequestedHelper,requestedDate,ViewIcon, proposalId}) => ({
      bRefNo, createdByHelper,reassignRequestedHelper,requestedDate, ViewIcon,proposalId
    }));
    apiResponse.data.content.simplifiedBriefRequests = newArray;
    return apiResponse;
  } catch (error) {
    throw error;
  }

}
export const getUserApproval = async (body) => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.GET_USER_APPROVAL_REQUESTS
  try {
    const apiResponse = await axios.post(endpoint, body, config);
    const data = apiResponse.data.content.userApprovalRequest
    const newArray = data.map(({ employeeName, role,employeeId, clusterName}) => ({
      employeeName, role,employeeId, clusterName
    }));
    apiResponse.data.content.simplifiedBriefRequests = newArray;
    return apiResponse;
  } catch (error) {
    throw error;
  }

}
export const getProposalReAssign = async (body) => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  const endpoint = Globals.BASE_URL + Globals.ENDPOINT.GET_PROPOSAL_REQUESTS;
  try {
    const apiResponse = await axios.post(endpoint, body, config);
    const data = apiResponse.data.content.proposalRequest
    const newArray = data.map(({proposalRefNo,producer, reassignRequestedHelper, requestedDate,reassignedCluster, reassignedChannel, proposalId,proposalDetailId}) => ({
      proposalRefNo, producer, reassignRequestedHelper,requestedDate, reassignedCluster, reassignedChannel, proposalId,proposalDetailId
    }));
    apiResponse.data.content.simplifiedBriefRequests = newArray;
    return apiResponse;
  } catch (error) {
    throw error;
  }

}


export const assignProposalSubmit = async (AssignProposalRequestBody) => {
  const endPoint = Globals.ENDPOINT.ASSIGN_PROPOSAL_POST + CryptoUtils.getFromLocalStorage("roleId");
  const apiResponse = await axios.post(endPoint, AssignProposalRequestBody);
  return apiResponse;
}

export const rejectUnsolicatedProposal = async (RejectProposalRequestBody) => {
  const endPoint = Globals.ENDPOINT.REJECT_PROPOSAL_POST + CryptoUtils.getFromLocalStorage("roleId");
  const apiResponse = await axios.post(endPoint, RejectProposalRequestBody);
  return apiResponse;
}

export const fetchCommisionEditors = async (roleId, clusterId) => {
  const apiResponse = await axios.get(Globals.ENDPOINT.UNSOLICITED_ASSIGN_PROPOSAL + `roleIds=${roleId}&clusterId=${clusterId}`);
  return apiResponse;
};

export const smEvaluationProposalSubmit = async (seniorManagerProposalRequestBody) => {

  const apiResponse = await axios.post(Globals.ENDPOINT.SM_EVALUATION_POST+'?roleId='+CryptoUtils.getFromLocalStorage("roleId").toString(), seniorManagerProposalRequestBody);
  return apiResponse;
}

export const hopEvaluationProposalSubmit = async (hopProposalRequestBody) => {

  const apiResponse = await axios.post(Globals.ENDPOINT.SM_EVALUATION_POST+'?roleId='+CryptoUtils.getFromLocalStorage("roleId").toString(), hopProposalRequestBody);
  return apiResponse;
}

export const fetchProposalReassign = async (proposalId,proposalDetailId) => {

  const endpoint = `${Globals.BASE_URL}${Globals.ENDPOINT.CC_UNSOLICITED_HALF_SCREEN}proposalId=${proposalId}&roleId=${CryptoUtils.getFromLocalStorage("roleId")}&proposalDetailId=${proposalDetailId}`
  try {
    const apiResponse = await axios.get(endpoint);
    return apiResponse;
  } catch (error) {
    console.error(error)
    throw error;
  }
}

//Handling pop for request tab SM flow

export const briefStatusUpdate = async (body) => {
  const apiResponse = await axios.put(`${Globals.ENDPOINT.BRIEF_STATUS_UPDATE}`, body, Globals.CONFIG);
  return apiResponse;

}
export const proposalStatusUpdate = async (body) => {
  const apiResponse = await axios.put(`${Globals.ENDPOINT.PROPOSAL_STATUS_UPDATE}`, body, Globals.CONFIG);
  return apiResponse;

}
export const briefShelveStatusUpdate = async (body) => {
  const apiResponse = await axios.put(`${Globals.ENDPOINT.BRIEF_SHELVE_STATUS_UPDATE}`, body, Globals.CONFIG);
  return apiResponse;

}
export const userProposalUpdate = async (body) => {
  const apiResponse = await axios.put(`${Globals.ENDPOINT.USER_APPROVAL_STATUS_UPDATE}`, body, Globals.CONFIG);
  return apiResponse;

}

export const fetchReassignDetails = async (proposalId,requestType) => {
  const endpoint = `${Globals.ENDPOINT.GET_BRIEF_REQUEST_BY_PROPOSALID}${proposalId}&requestType=${requestType}`

  const api_response = await axios.post(endpoint, Globals.CONFIG)
  return api_response
}
  export const smEvaluationProposalData = async (proposalDetailId,proposalId) =>{
    const apiResponse = await axios.get(Globals.ENDPOINT.SM_EVALUATION_LIST+`proposalDetailId=${proposalDetailId}&roleId=${CryptoUtils.getFromLocalStorage("roleId")}&proposalId=${proposalId}`);
    return apiResponse;
    }
    
  
export const createClusterApi = async (body) => {
    const config = {
        headers: {
          'Content-Type': 'application/json' // Set the Content-Type header
        }
      };
    const apiResponse = await axios.post(Globals.ENDPOINT.CREATE_CLUSTER,body,config);
    return apiResponse;
};

export const updateClusterApi = async (body,clusterId) => {
  const config = {
      headers: {
        'Content-Type': 'application/json' // Set the Content-Type header
      }
    };
  const apiResponse = await axios.put(Globals.ENDPOINT.UPDATE_CLUSTER+clusterId,body,config);
  return apiResponse;
};

export const deleteClusterApi = async (clusterId) => {
  const apiResponse = await axios.delete(Globals.ENDPOINT.DELETE_CLUSTER+clusterId);
  return apiResponse;
};

export const fetchAllScriptTypes = async () => {
  const apiResponse = await axios.get(Globals.ENDPOINT.FETCH_ALL_SCRIPTTYPES);
  return apiResponse;
};

export const updateFavourite = async (isFavourite, proposalDetailId,roleId) => {
  const endpoint = `${Globals.ENDPOINT.UPDATE_FAVOURITE}${isFavourite}&proposalDetailId=${proposalDetailId}&roleId=${roleId}`;
  const api_response = await axios.post(endpoint, Globals.CONFIG)
  return api_response
}
export const fetchAllProposalsOrBriefsByProducerId = async (ticketType) => {
  const apiResponse = await axios.get(Globals.ENDPOINT.FETCH_PROPOSALS_BY_PRODUCER_ID + ticketType);
  return apiResponse;
};

export const CreateTicket = async (body) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  const endpoint=Globals.ENDPOINT.CREATE_TICKET;
  const apiResponse = await axios.post(endpoint, body, config);
  return apiResponse;
};

export const fetchProducerTickets = async (ticketType, periodFilter, Filters, pageNumber) => {
  if (ticketType && periodFilter && Filters) {
    const body = {
      take: 5,
      skip: pageNumber,
      dataFilters: Filters,
      ticketStatusType: ticketType,
      ticketPeriodFilter: periodFilter
    };
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };

    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.PRODUCER_TICKETS;
    const apiResponse = await axios.post(endpoint, body, config);
    return apiResponse;
  }
};

export const fetchCCTickets = async (ticketType, periodFilter, Filters, pageNumber, clusterId) => {
  if (ticketType && periodFilter && Filters) {
    const body = {
      take: 5,
      skip: pageNumber,
      dataFilters: Filters,
      ticketStatusType: ticketType,
      ticketPeriodFilter: periodFilter,
      clusterId: clusterId
    };
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };

    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.CC_TICKETS;
    const apiResponse = await axios.post(endpoint, body, config);
    return apiResponse;
  }
};

export const ticketStatusUpdate = async(ticketId) => {
  const endpoint= `${Globals.ENDPOINT.UPDATE_TICKET_STATUS}${ticketId}`;
  const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };
  const apiResponse = await axios.post(endpoint,config);
  return apiResponse;
}

export const fetchCETickets = async (ticketType, periodFilter, Filters, pageNumber, clusterId) => {
  if (ticketType && periodFilter && Filters) {
    const body = {
      take: 5,
      skip: pageNumber,
      dataFilters: Filters,
      ticketStatusType: ticketType,
      ticketPeriodFilter: periodFilter,
      clusterId: clusterId
    };
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };

    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.CE_TICKETS;
    const apiResponse = await axios.post(endpoint, body, config);
    return apiResponse;
  }
};

export const fetchSystemAdminTickets = async (ticketType, periodFilter, Filters, pageNumber, clusterId) => {
  if (ticketType && periodFilter && Filters) {
    const body = {
      take: 5,
      skip: pageNumber,
      dataFilters: Filters,
      ticketStatusType: ticketType,
      ticketPeriodFilter: periodFilter,
      clusterId: 0
    };
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };

    const endpoint = Globals.BASE_URL + Globals.ENDPOINT.SA_TICKETS;
    const apiResponse = await axios.post(endpoint, body, config);
    return apiResponse;
  }
};

export const fetchDraftedCEEvalScores = async (proposalID, proposalDetailId) => {
const apiResponse = await axios.get(Globals.ENDPOINT.CE_DRAFTED_EVAL_SCORES+'?proposalId='+proposalID+'&proposalDetailId='+proposalDetailId);
  return apiResponse;
}

export const fetchDraftedSMEvalScores = async (proposalID, proposalDetailId) => {
  const apiResponse = await axios.get(Globals.ENDPOINT.SM_DRAFTED_EVAL_SCORES+'?proposalId='+proposalID+'&proposalDetailId='+proposalDetailId);
    return apiResponse;
}